import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const fetchVisitorCount = async (data) => {
  return await axios.post(`${API_BASE_URL}/visitor`, data, { });
};